module.exports = __webpack_public_path__ + "static/media/stats.85881b43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/stats.svg
// module id = 2719
// module chunks = 0